import _definePage_default_0 from '/app/resources/ts/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/resources/ts/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/app/resources/ts/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_4 from '/app/resources/ts/pages/administration/ai-assistants.vue?definePage&vue'
import _definePage_default_5 from '/app/resources/ts/pages/administration/ai-connectors.vue?definePage&vue'
import _definePage_default_6 from '/app/resources/ts/pages/administration/ai-profiles.vue?definePage&vue'
import _definePage_default_7 from '/app/resources/ts/pages/administration/ai-prompts.vue?definePage&vue'
import _definePage_default_8 from '/app/resources/ts/pages/administration/api-tokens.vue?definePage&vue'
import _definePage_default_9 from '/app/resources/ts/pages/administration/audit-logs.vue?definePage&vue'
import _definePage_default_10 from '/app/resources/ts/pages/administration/email-stop-list.vue?definePage&vue'
import _definePage_default_11 from '/app/resources/ts/pages/administration/games.vue?definePage&vue'
import _definePage_default_12 from '/app/resources/ts/pages/administration/loop-avatars.vue?definePage&vue'
import _definePage_default_13 from '/app/resources/ts/pages/administration/maintenance.vue?definePage&vue'
import _definePage_default_14 from '/app/resources/ts/pages/administration/org-activity.vue?definePage&vue'
import _definePage_default_15 from '/app/resources/ts/pages/administration/organization-subscriptions.vue?definePage&vue'
import _definePage_default_16 from '/app/resources/ts/pages/administration/organizations.vue?definePage&vue'
import _definePage_default_17 from '/app/resources/ts/pages/administration/realtime-avatars.vue?definePage&vue'
import _definePage_default_18 from '/app/resources/ts/pages/administration/subscription-plans.vue?definePage&vue'
import _definePage_default_19 from '/app/resources/ts/pages/administration/tts-voices.vue?definePage&vue'
import _definePage_default_20 from '/app/resources/ts/pages/apps/chat.vue?definePage&vue'
import _definePage_default_21 from '/app/resources/ts/pages/apps/email/index.vue?definePage&vue'
import _definePage_default_22 from '/app/resources/ts/pages/apps/logistics/fleet.vue?definePage&vue'
import _definePage_default_23 from '/app/resources/ts/pages/c/[token].vue?definePage&vue'
import _definePage_default_24 from '/app/resources/ts/pages/dashboards/expert.vue?definePage&vue'
import _definePage_default_25 from '/app/resources/ts/pages/dashboards/head.vue?definePage&vue'
import _definePage_default_26 from '/app/resources/ts/pages/dashboards/manager.vue?definePage&vue'
import _definePage_default_27 from '/app/resources/ts/pages/dashboards/player.vue?definePage&vue'
import _definePage_default_28 from '/app/resources/ts/pages/external-launch/connections.vue?definePage&vue'
import _definePage_default_29 from '/app/resources/ts/pages/external-launch/journal/[publication].vue?definePage&vue'
import _definePage_default_30 from '/app/resources/ts/pages/external-launch/publications.vue?definePage&vue'
import _definePage_default_31 from '/app/resources/ts/pages/external-review/[launch].vue?definePage&vue'
import _definePage_default_32 from '/app/resources/ts/pages/faq/list.vue?definePage&vue'
import _definePage_default_33 from '/app/resources/ts/pages/forgot-password.vue?definePage&vue'
import _definePage_default_34 from '/app/resources/ts/pages/front-pages/checkout.vue?definePage&vue'
import _definePage_default_35 from '/app/resources/ts/pages/front-pages/help-center/index.vue?definePage&vue'
import _definePage_default_36 from '/app/resources/ts/pages/front-pages/help-center/article/[title].vue?definePage&vue'
import _definePage_default_37 from '/app/resources/ts/pages/front-pages/landing-page/index.vue?definePage&vue'
import _definePage_default_38 from '/app/resources/ts/pages/front-pages/payment.vue?definePage&vue'
import _definePage_default_39 from '/app/resources/ts/pages/front-pages/pricing.vue?definePage&vue'
import _definePage_default_40 from '/app/resources/ts/pages/games/ai-reports.vue?definePage&vue'
import _definePage_default_41 from '/app/resources/ts/pages/games/ai-study-chat.vue?definePage&vue'
import _definePage_default_42 from '/app/resources/ts/pages/games/competencies/list.vue?definePage&vue'
import _definePage_default_43 from '/app/resources/ts/pages/games/competencies/rubrics.vue?definePage&vue'
import _definePage_default_44 from '/app/resources/ts/pages/games/competencies/skills.vue?definePage&vue'
import _definePage_default_45 from '/app/resources/ts/pages/games/courses.vue?definePage&vue'
import _definePage_default_46 from '/app/resources/ts/pages/games/detail/[id].vue?definePage&vue'
import _definePage_default_47 from '/app/resources/ts/pages/games/knowledge-base.vue?definePage&vue'
import _definePage_default_48 from '/app/resources/ts/pages/games/library/[id].vue?definePage&vue'
import _definePage_default_49 from '/app/resources/ts/pages/games/library/documents.vue?definePage&vue'
import _definePage_default_50 from '/app/resources/ts/pages/games/library/scorm.vue?definePage&vue'
import _definePage_default_51 from '/app/resources/ts/pages/games/library/scorm-tiles.vue?definePage&vue'
import _definePage_default_52 from '/app/resources/ts/pages/games/library/video.vue?definePage&vue'
import _definePage_default_53 from '/app/resources/ts/pages/games/library/video-tiles.vue?definePage&vue'
import _definePage_default_54 from '/app/resources/ts/pages/games/list.vue?definePage&vue'
import _definePage_default_55 from '/app/resources/ts/pages/games/play/[id].vue?definePage&vue'
import _definePage_default_56 from '/app/resources/ts/pages/games/scenarios/[id].vue?definePage&vue'
import _definePage_default_57 from '/app/resources/ts/pages/games/scenarios/list.vue?definePage&vue'
import _definePage_default_58 from '/app/resources/ts/pages/games/session/[id].vue?definePage&vue'
import _definePage_default_59 from '/app/resources/ts/pages/games/tours.vue?definePage&vue'
import _definePage_default_60 from '/app/resources/ts/pages/login.vue?definePage&vue'
import _definePage_default_61 from '/app/resources/ts/pages/not-authorized.vue?definePage&vue'
import _definePage_default_62 from '/app/resources/ts/pages/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_63 from '/app/resources/ts/pages/pages/authentication/forgot-password-v1.vue?definePage&vue'
import _definePage_default_64 from '/app/resources/ts/pages/pages/authentication/forgot-password-v2.vue?definePage&vue'
import _definePage_default_65 from '/app/resources/ts/pages/pages/authentication/login-v1.vue?definePage&vue'
import _definePage_default_66 from '/app/resources/ts/pages/pages/authentication/login-v2.vue?definePage&vue'
import _definePage_default_67 from '/app/resources/ts/pages/pages/authentication/register-multi-steps.vue?definePage&vue'
import _definePage_default_68 from '/app/resources/ts/pages/pages/authentication/register-v1.vue?definePage&vue'
import _definePage_default_69 from '/app/resources/ts/pages/pages/authentication/register-v2.vue?definePage&vue'
import _definePage_default_70 from '/app/resources/ts/pages/pages/authentication/reset-password-v1.vue?definePage&vue'
import _definePage_default_71 from '/app/resources/ts/pages/pages/authentication/reset-password-v2.vue?definePage&vue'
import _definePage_default_72 from '/app/resources/ts/pages/pages/authentication/two-steps-v1.vue?definePage&vue'
import _definePage_default_73 from '/app/resources/ts/pages/pages/authentication/two-steps-v2.vue?definePage&vue'
import _definePage_default_74 from '/app/resources/ts/pages/pages/authentication/verify-email-v1.vue?definePage&vue'
import _definePage_default_75 from '/app/resources/ts/pages/pages/authentication/verify-email-v2.vue?definePage&vue'
import _definePage_default_76 from '/app/resources/ts/pages/pages/misc/coming-soon.vue?definePage&vue'
import _definePage_default_77 from '/app/resources/ts/pages/pages/misc/under-maintenance.vue?definePage&vue'
import _definePage_default_78 from '/app/resources/ts/pages/pages/user-profile/[tab].vue?definePage&vue'
import _definePage_default_79 from '/app/resources/ts/pages/password-reset/[token].vue?definePage&vue'
import _definePage_default_80 from '/app/resources/ts/pages/recruiting/index.vue?definePage&vue'
import _definePage_default_81 from '/app/resources/ts/pages/recruiting/[id].vue?definePage&vue'
import _definePage_default_82 from '/app/resources/ts/pages/register.vue?definePage&vue'
import _definePage_default_83 from '/app/resources/ts/pages/reports/analytics/competencies.vue?definePage&vue'
import _definePage_default_84 from '/app/resources/ts/pages/reports/analytics/tours.vue?definePage&vue'
import _definePage_default_85 from '/app/resources/ts/pages/reports/ranking.vue?definePage&vue'
import _definePage_default_86 from '/app/resources/ts/pages/two-factor-challenge.vue?definePage&vue'
import _definePage_default_87 from '/app/resources/ts/pages/users/chat.vue?definePage&vue'
import _definePage_default_88 from '/app/resources/ts/pages/users/custom-fields.vue?definePage&vue'
import _definePage_default_89 from '/app/resources/ts/pages/users/departments.vue?definePage&vue'
import _definePage_default_90 from '/app/resources/ts/pages/users/list.vue?definePage&vue'
import _definePage_default_91 from '/app/resources/ts/pages/users/positions.vue?definePage&vue'
import _definePage_default_92 from '/app/resources/ts/pages/users/view/[id].vue?definePage&vue'
import _definePage_default_93 from '/app/resources/ts/pages/verify-done.vue?definePage&vue'
import _definePage_default_94 from '/app/resources/ts/pages/verify-email.vue?definePage&vue'
import _definePage_default_95 from '/app/resources/ts/pages/x/[code].vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/resources/ts/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/app/resources/ts/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/account-settings',
    /* internal name: 'account-settings' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':tab',
        name: 'account-settings-tab',
        component: () => import('/app/resources/ts/pages/account-settings/[tab].vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  {
    path: '/administration',
    /* internal name: 'administration' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'ai-assistants',
        name: 'administration-ai-assistants',
        component: () => import('/app/resources/ts/pages/administration/ai-assistants.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'ai-connectors',
        name: 'administration-ai-connectors',
        component: () => import('/app/resources/ts/pages/administration/ai-connectors.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
  _mergeRouteRecord(
      {
        path: 'ai-profiles',
        name: 'administration-ai-profiles',
        component: () => import('/app/resources/ts/pages/administration/ai-profiles.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: 'ai-prompts',
        name: 'administration-ai-prompts',
        component: () => import('/app/resources/ts/pages/administration/ai-prompts.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'api-tokens',
        name: 'administration-api-tokens',
        component: () => import('/app/resources/ts/pages/administration/api-tokens.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'audit-logs',
        name: 'administration-audit-logs',
        component: () => import('/app/resources/ts/pages/administration/audit-logs.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
  _mergeRouteRecord(
      {
        path: 'email-stop-list',
        name: 'administration-email-stop-list',
        component: () => import('/app/resources/ts/pages/administration/email-stop-list.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
  _mergeRouteRecord(
      {
        path: 'games',
        name: 'administration-games',
        component: () => import('/app/resources/ts/pages/administration/games.vue'),
        /* no children */
      },
  _definePage_default_11
  ),
  _mergeRouteRecord(
      {
        path: 'loop-avatars',
        name: 'administration-loop-avatars',
        component: () => import('/app/resources/ts/pages/administration/loop-avatars.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'maintenance',
        name: 'administration-maintenance',
        component: () => import('/app/resources/ts/pages/administration/maintenance.vue'),
        /* no children */
      },
  _definePage_default_13
  ),
  _mergeRouteRecord(
      {
        path: 'org-activity',
        name: 'administration-org-activity',
        component: () => import('/app/resources/ts/pages/administration/org-activity.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: 'organization-subscriptions',
        name: 'administration-organization-subscriptions',
        component: () => import('/app/resources/ts/pages/administration/organization-subscriptions.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
  _mergeRouteRecord(
      {
        path: 'organizations',
        name: 'administration-organizations',
        component: () => import('/app/resources/ts/pages/administration/organizations.vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'realtime-avatars',
        name: 'administration-realtime-avatars',
        component: () => import('/app/resources/ts/pages/administration/realtime-avatars.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
  _mergeRouteRecord(
      {
        path: 'subscription-plans',
        name: 'administration-subscription-plans',
        component: () => import('/app/resources/ts/pages/administration/subscription-plans.vue'),
        /* no children */
      },
  _definePage_default_18
  ),
  _mergeRouteRecord(
      {
        path: 'tts-voices',
        name: 'administration-tts-voices',
        component: () => import('/app/resources/ts/pages/administration/tts-voices.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'academy',
        /* internal name: 'apps-academy' */
        /* no component */
        children: [
          {
            path: 'course-details',
            name: 'apps-academy-course-details',
            component: () => import('/app/resources/ts/pages/apps/academy/course-details.vue'),
            /* no children */
          },
          {
            path: 'dashboard',
            name: 'apps-academy-dashboard',
            component: () => import('/app/resources/ts/pages/apps/academy/dashboard.vue'),
            /* no children */
          },
          {
            path: 'my-course',
            name: 'apps-academy-my-course',
            component: () => import('/app/resources/ts/pages/apps/academy/my-course.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'calendar',
        name: 'apps-calendar',
        component: () => import('/app/resources/ts/pages/apps/calendar.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'apps-chat',
        component: () => import('/app/resources/ts/pages/apps/chat.vue'),
        /* no children */
      },
  _definePage_default_20
  ),
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'customer',
            /* internal name: 'apps-ecommerce-customer' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-customer-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-customer-details-id',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/customer/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-customer-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-customer-list',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/customer/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/app/resources/ts/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-product-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-add',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/product/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'category-list',
                name: 'apps-ecommerce-product-category-list',
                component: () => import('/app/resources/ts/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/app/resources/ts/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'referrals',
            name: 'apps-ecommerce-referrals',
            component: () => import('/app/resources/ts/pages/apps/ecommerce/referrals.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/app/resources/ts/pages/apps/ecommerce/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email',
        /* internal name: 'apps-email' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-email',
            component: () => import('/app/resources/ts/pages/apps/email/index.vue'),
            /* no children */
          },
  _definePage_default_21
  )
        ],
      },
      {
        path: 'invoice',
        /* internal name: 'apps-invoice' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'apps-invoice-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-add',
                component: () => import('/app/resources/ts/pages/apps/invoice/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'apps-invoice-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-edit-id',
                component: () => import('/app/resources/ts/pages/apps/invoice/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            /* internal name: 'apps-invoice-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-list',
                component: () => import('/app/resources/ts/pages/apps/invoice/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: 'apps-invoice-preview' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-preview-id',
                component: () => import('/app/resources/ts/pages/apps/invoice/preview/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'logistics',
        /* internal name: 'apps-logistics' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-logistics-dashboard',
            component: () => import('/app/resources/ts/pages/apps/logistics/dashboard.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'fleet',
            name: 'apps-logistics-fleet',
            component: () => import('/app/resources/ts/pages/apps/logistics/fleet.vue'),
            /* no children */
          },
  _definePage_default_22
  )
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/app/resources/ts/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/app/resources/ts/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/app/resources/ts/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/app/resources/ts/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/apps/email/:filter',
    name: 'apps-email-filter',
    component: () => import('/resources/ts/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/apps/email/:label',
    name: 'apps-email-label',
    component: () => import('/resources/ts/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/c',
    /* internal name: 'c' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'c-token',
        component: () => import('/app/resources/ts/pages/c/[token].vue'),
        /* no children */
      },
  _definePage_default_23
  )
    ],
  },
  {
    path: '/charts',
    /* internal name: 'charts' */
    /* no component */
    children: [
      {
        path: 'apex-chart',
        name: 'charts-apex-chart',
        component: () => import('/app/resources/ts/pages/charts/apex-chart.vue'),
        /* no children */
      },
      {
        path: 'chartjs',
        name: 'charts-chartjs',
        component: () => import('/app/resources/ts/pages/charts/chartjs.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/components',
    /* internal name: 'components' */
    /* no component */
    children: [
      {
        path: 'alert',
        name: 'components-alert',
        component: () => import('/app/resources/ts/pages/components/alert.vue'),
        /* no children */
      },
      {
        path: 'avatar',
        name: 'components-avatar',
        component: () => import('/app/resources/ts/pages/components/avatar.vue'),
        /* no children */
      },
      {
        path: 'badge',
        name: 'components-badge',
        component: () => import('/app/resources/ts/pages/components/badge.vue'),
        /* no children */
      },
      {
        path: 'button',
        name: 'components-button',
        component: () => import('/app/resources/ts/pages/components/button.vue'),
        /* no children */
      },
      {
        path: 'chip',
        name: 'components-chip',
        component: () => import('/app/resources/ts/pages/components/chip.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: 'components-dialog',
        component: () => import('/app/resources/ts/pages/components/dialog.vue'),
        /* no children */
      },
      {
        path: 'expansion-panel',
        name: 'components-expansion-panel',
        component: () => import('/app/resources/ts/pages/components/expansion-panel.vue'),
        /* no children */
      },
      {
        path: 'list',
        name: 'components-list',
        component: () => import('/app/resources/ts/pages/components/list.vue'),
        /* no children */
      },
      {
        path: 'menu',
        name: 'components-menu',
        component: () => import('/app/resources/ts/pages/components/menu.vue'),
        /* no children */
      },
      {
        path: 'pagination',
        name: 'components-pagination',
        component: () => import('/app/resources/ts/pages/components/pagination.vue'),
        /* no children */
      },
      {
        path: 'progress-circular',
        name: 'components-progress-circular',
        component: () => import('/app/resources/ts/pages/components/progress-circular.vue'),
        /* no children */
      },
      {
        path: 'progress-linear',
        name: 'components-progress-linear',
        component: () => import('/app/resources/ts/pages/components/progress-linear.vue'),
        /* no children */
      },
      {
        path: 'snackbar',
        name: 'components-snackbar',
        component: () => import('/app/resources/ts/pages/components/snackbar.vue'),
        /* no children */
      },
      {
        path: 'tabs',
        name: 'components-tabs',
        component: () => import('/app/resources/ts/pages/components/tabs.vue'),
        /* no children */
      },
      {
        path: 'timeline',
        name: 'components-timeline',
        component: () => import('/app/resources/ts/pages/components/timeline.vue'),
        /* no children */
      },
      {
        path: 'tooltip',
        name: 'components-tooltip',
        component: () => import('/app/resources/ts/pages/components/tooltip.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/app/resources/ts/pages/dashboards/analytics.vue'),
        /* no children */
      },
      {
        path: 'crm',
        name: 'dashboards-crm',
        component: () => import('/app/resources/ts/pages/dashboards/crm.vue'),
        /* no children */
      },
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/app/resources/ts/pages/dashboards/ecommerce.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'expert',
        name: 'dashboards-expert',
        component: () => import('/app/resources/ts/pages/dashboards/expert.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
  _mergeRouteRecord(
      {
        path: 'head',
        name: 'dashboards-head',
        component: () => import('/app/resources/ts/pages/dashboards/head.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'manager',
        name: 'dashboards-manager',
        component: () => import('/app/resources/ts/pages/dashboards/manager.vue'),
        /* no children */
      },
  _definePage_default_26
  ),
  _mergeRouteRecord(
      {
        path: 'player',
        name: 'dashboards-player',
        component: () => import('/app/resources/ts/pages/dashboards/player.vue'),
        /* no children */
      },
  _definePage_default_27
  )
    ],
  },
  {
    path: '/extensions',
    /* internal name: 'extensions' */
    /* no component */
    children: [
      {
        path: 'swiper',
        name: 'extensions-swiper',
        component: () => import('/app/resources/ts/pages/extensions/swiper.vue'),
        /* no children */
      },
      {
        path: 'tour',
        name: 'extensions-tour',
        component: () => import('/app/resources/ts/pages/extensions/tour.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/external-launch',
    /* internal name: 'external-launch' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'connections',
        name: 'external-launch-connections',
        component: () => import('/app/resources/ts/pages/external-launch/connections.vue'),
        /* no children */
      },
  _definePage_default_28
  ),
      {
        path: 'journal',
        /* internal name: 'external-launch-journal' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':publication',
            name: 'external-launch-journal-publication',
            component: () => import('/app/resources/ts/pages/external-launch/journal/[publication].vue'),
            /* no children */
          },
  _definePage_default_29
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'publications',
        name: 'external-launch-publications',
        component: () => import('/app/resources/ts/pages/external-launch/publications.vue'),
        /* no children */
      },
  _definePage_default_30
  )
    ],
  },
  {
    path: '/external-review',
    /* internal name: 'external-review' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':launch',
        name: 'external-review-launch',
        component: () => import('/app/resources/ts/pages/external-review/[launch].vue'),
        /* no children */
      },
  _definePage_default_31
  )
    ],
  },
  {
    path: '/faq',
    /* internal name: 'faq' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'faq-list',
        component: () => import('/app/resources/ts/pages/faq/list.vue'),
        /* no children */
      },
  _definePage_default_32
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/app/resources/ts/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_33
  ),
  {
    path: '/forms',
    /* internal name: 'forms' */
    /* no component */
    children: [
      {
        path: 'autocomplete',
        name: 'forms-autocomplete',
        component: () => import('/app/resources/ts/pages/forms/autocomplete.vue'),
        /* no children */
      },
      {
        path: 'checkbox',
        name: 'forms-checkbox',
        component: () => import('/app/resources/ts/pages/forms/checkbox.vue'),
        /* no children */
      },
      {
        path: 'combobox',
        name: 'forms-combobox',
        component: () => import('/app/resources/ts/pages/forms/combobox.vue'),
        /* no children */
      },
      {
        path: 'custom-input',
        name: 'forms-custom-input',
        component: () => import('/app/resources/ts/pages/forms/custom-input.vue'),
        /* no children */
      },
      {
        path: 'date-time-picker',
        name: 'forms-date-time-picker',
        component: () => import('/app/resources/ts/pages/forms/date-time-picker.vue'),
        /* no children */
      },
      {
        path: 'editors',
        name: 'forms-editors',
        component: () => import('/app/resources/ts/pages/forms/editors.vue'),
        /* no children */
      },
      {
        path: 'file-input',
        name: 'forms-file-input',
        component: () => import('/app/resources/ts/pages/forms/file-input.vue'),
        /* no children */
      },
      {
        path: 'form-layouts',
        name: 'forms-form-layouts',
        component: () => import('/app/resources/ts/pages/forms/form-layouts.vue'),
        /* no children */
      },
      {
        path: 'form-validation',
        name: 'forms-form-validation',
        component: () => import('/app/resources/ts/pages/forms/form-validation.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-icons',
        name: 'forms-form-wizard-icons',
        component: () => import('/app/resources/ts/pages/forms/form-wizard-icons.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-numbered',
        name: 'forms-form-wizard-numbered',
        component: () => import('/app/resources/ts/pages/forms/form-wizard-numbered.vue'),
        /* no children */
      },
      {
        path: 'radio',
        name: 'forms-radio',
        component: () => import('/app/resources/ts/pages/forms/radio.vue'),
        /* no children */
      },
      {
        path: 'range-slider',
        name: 'forms-range-slider',
        component: () => import('/app/resources/ts/pages/forms/range-slider.vue'),
        /* no children */
      },
      {
        path: 'rating',
        name: 'forms-rating',
        component: () => import('/app/resources/ts/pages/forms/rating.vue'),
        /* no children */
      },
      {
        path: 'select',
        name: 'forms-select',
        component: () => import('/app/resources/ts/pages/forms/select.vue'),
        /* no children */
      },
      {
        path: 'slider',
        name: 'forms-slider',
        component: () => import('/app/resources/ts/pages/forms/slider.vue'),
        /* no children */
      },
      {
        path: 'switch',
        name: 'forms-switch',
        component: () => import('/app/resources/ts/pages/forms/switch.vue'),
        /* no children */
      },
      {
        path: 'textarea',
        name: 'forms-textarea',
        component: () => import('/app/resources/ts/pages/forms/textarea.vue'),
        /* no children */
      },
      {
        path: 'textfield',
        name: 'forms-textfield',
        component: () => import('/app/resources/ts/pages/forms/textfield.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/front-pages',
    /* internal name: 'front-pages' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'checkout',
        name: 'front-pages-checkout',
        component: () => import('/app/resources/ts/pages/front-pages/checkout.vue'),
        /* no children */
      },
  _definePage_default_34
  ),
      {
        path: 'help-center',
        /* internal name: 'front-pages-help-center' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-help-center',
            component: () => import('/app/resources/ts/pages/front-pages/help-center/index.vue'),
            /* no children */
          },
  _definePage_default_35
  ),
          {
            path: 'article',
            /* internal name: 'front-pages-help-center-article' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':title',
                name: 'front-pages-help-center-article-title',
                component: () => import('/app/resources/ts/pages/front-pages/help-center/article/[title].vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          }
        ],
      },
      {
        path: 'landing-page',
        /* internal name: 'front-pages-landing-page' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-landing-page',
            component: () => import('/app/resources/ts/pages/front-pages/landing-page/index.vue'),
            /* no children */
          },
  _definePage_default_37
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'payment',
        name: 'front-pages-payment',
        component: () => import('/app/resources/ts/pages/front-pages/payment.vue'),
        /* no children */
      },
  _definePage_default_38
  ),
  _mergeRouteRecord(
      {
        path: 'pricing',
        name: 'front-pages-pricing',
        component: () => import('/app/resources/ts/pages/front-pages/pricing.vue'),
        /* no children */
      },
  _definePage_default_39
  )
    ],
  },
  {
    path: '/games',
    /* internal name: 'games' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'ai-reports',
        name: 'games-ai-reports',
        component: () => import('/app/resources/ts/pages/games/ai-reports.vue'),
        /* no children */
      },
  _definePage_default_40
  ),
  _mergeRouteRecord(
      {
        path: 'ai-study-chat',
        name: 'games-ai-study-chat',
        component: () => import('/app/resources/ts/pages/games/ai-study-chat.vue'),
        /* no children */
      },
  _definePage_default_41
  ),
      {
        path: 'competencies',
        /* internal name: 'games-competencies' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'list',
            name: 'games-competencies-list',
            component: () => import('/app/resources/ts/pages/games/competencies/list.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
  _mergeRouteRecord(
          {
            path: 'rubrics',
            name: 'games-competencies-rubrics',
            component: () => import('/app/resources/ts/pages/games/competencies/rubrics.vue'),
            /* no children */
          },
  _definePage_default_43
  ),
  _mergeRouteRecord(
          {
            path: 'skills',
            name: 'games-competencies-skills',
            component: () => import('/app/resources/ts/pages/games/competencies/skills.vue'),
            /* no children */
          },
  _definePage_default_44
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'courses',
        name: 'games-courses',
        component: () => import('/app/resources/ts/pages/games/courses.vue'),
        /* no children */
      },
  _definePage_default_45
  ),
      {
        path: 'detail',
        /* internal name: 'games-detail' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'games-detail-id',
            component: () => import('/app/resources/ts/pages/games/detail/[id].vue'),
            /* no children */
          },
  _definePage_default_46
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'knowledge-base',
        name: 'games-knowledge-base',
        component: () => import('/app/resources/ts/pages/games/knowledge-base.vue'),
        /* no children */
      },
  _definePage_default_47
  ),
      {
        path: 'library',
        /* internal name: 'games-library' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'games-library-id',
            component: () => import('/app/resources/ts/pages/games/library/[id].vue'),
            /* no children */
          },
  _definePage_default_48
  ),
  _mergeRouteRecord(
          {
            path: 'documents',
            name: 'games-library-documents',
            component: () => import('/app/resources/ts/pages/games/library/documents.vue'),
            /* no children */
          },
  _definePage_default_49
  ),
  _mergeRouteRecord(
          {
            path: 'scorm',
            name: 'games-library-scorm',
            component: () => import('/app/resources/ts/pages/games/library/scorm.vue'),
            /* no children */
          },
  _definePage_default_50
  ),
  _mergeRouteRecord(
          {
            path: 'scorm-tiles',
            name: 'games-library-scorm-tiles',
            component: () => import('/app/resources/ts/pages/games/library/scorm-tiles.vue'),
            /* no children */
          },
  _definePage_default_51
  ),
  _mergeRouteRecord(
          {
            path: 'video',
            name: 'games-library-video',
            component: () => import('/app/resources/ts/pages/games/library/video.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
  _mergeRouteRecord(
          {
            path: 'video-tiles',
            name: 'games-library-video-tiles',
            component: () => import('/app/resources/ts/pages/games/library/video-tiles.vue'),
            /* no children */
          },
  _definePage_default_53
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'games-list',
        component: () => import('/app/resources/ts/pages/games/list.vue'),
        /* no children */
      },
  _definePage_default_54
  ),
      {
        path: 'play',
        /* internal name: 'games-play' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'games-play-id',
            component: () => import('/app/resources/ts/pages/games/play/[id].vue'),
            /* no children */
          },
  _definePage_default_55
  )
        ],
      },
      {
        path: 'scenarios',
        /* internal name: 'games-scenarios' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'games-scenarios-id',
            component: () => import('/app/resources/ts/pages/games/scenarios/[id].vue'),
            /* no children */
          },
  _definePage_default_56
  ),
  _mergeRouteRecord(
          {
            path: 'list',
            name: 'games-scenarios-list',
            component: () => import('/app/resources/ts/pages/games/scenarios/list.vue'),
            /* no children */
          },
  _definePage_default_57
  )
        ],
      },
      {
        path: 'session',
        /* internal name: 'games-session' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'games-session-id',
            component: () => import('/app/resources/ts/pages/games/session/[id].vue'),
            /* no children */
          },
  _definePage_default_58
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'tours',
        name: 'games-tours',
        component: () => import('/app/resources/ts/pages/games/tours.vue'),
        /* no children */
      },
  _definePage_default_59
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/resources/ts/pages/login.vue'),
    /* no children */
  },
  _definePage_default_60
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/app/resources/ts/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_61
  ),
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'account-settings',
        /* internal name: 'pages-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-account-settings-tab',
            component: () => import('/app/resources/ts/pages/pages/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_62
  )
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'pages-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password-v1',
            name: 'pages-authentication-forgot-password-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/forgot-password-v1.vue'),
            /* no children */
          },
  _definePage_default_63
  ),
  _mergeRouteRecord(
          {
            path: 'forgot-password-v2',
            name: 'pages-authentication-forgot-password-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/forgot-password-v2.vue'),
            /* no children */
          },
  _definePage_default_64
  ),
  _mergeRouteRecord(
          {
            path: 'login-v1',
            name: 'pages-authentication-login-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/login-v1.vue'),
            /* no children */
          },
  _definePage_default_65
  ),
  _mergeRouteRecord(
          {
            path: 'login-v2',
            name: 'pages-authentication-login-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/login-v2.vue'),
            /* no children */
          },
  _definePage_default_66
  ),
  _mergeRouteRecord(
          {
            path: 'register-multi-steps',
            name: 'pages-authentication-register-multi-steps',
            component: () => import('/app/resources/ts/pages/pages/authentication/register-multi-steps.vue'),
            /* no children */
          },
  _definePage_default_67
  ),
  _mergeRouteRecord(
          {
            path: 'register-v1',
            name: 'pages-authentication-register-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/register-v1.vue'),
            /* no children */
          },
  _definePage_default_68
  ),
  _mergeRouteRecord(
          {
            path: 'register-v2',
            name: 'pages-authentication-register-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/register-v2.vue'),
            /* no children */
          },
  _definePage_default_69
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v1',
            name: 'pages-authentication-reset-password-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/reset-password-v1.vue'),
            /* no children */
          },
  _definePage_default_70
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v2',
            name: 'pages-authentication-reset-password-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/reset-password-v2.vue'),
            /* no children */
          },
  _definePage_default_71
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v1',
            name: 'pages-authentication-two-steps-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/two-steps-v1.vue'),
            /* no children */
          },
  _definePage_default_72
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v2',
            name: 'pages-authentication-two-steps-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/two-steps-v2.vue'),
            /* no children */
          },
  _definePage_default_73
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v1',
            name: 'pages-authentication-verify-email-v1',
            component: () => import('/app/resources/ts/pages/pages/authentication/verify-email-v1.vue'),
            /* no children */
          },
  _definePage_default_74
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v2',
            name: 'pages-authentication-verify-email-v2',
            component: () => import('/app/resources/ts/pages/pages/authentication/verify-email-v2.vue'),
            /* no children */
          },
  _definePage_default_75
  )
        ],
      },
      {
        path: 'cards',
        /* internal name: 'pages-cards' */
        /* no component */
        children: [
          {
            path: 'card-actions',
            name: 'pages-cards-card-actions',
            component: () => import('/app/resources/ts/pages/pages/cards/card-actions.vue'),
            /* no children */
          },
          {
            path: 'card-advance',
            name: 'pages-cards-card-advance',
            component: () => import('/app/resources/ts/pages/pages/cards/card-advance.vue'),
            /* no children */
          },
          {
            path: 'card-basic',
            name: 'pages-cards-card-basic',
            component: () => import('/app/resources/ts/pages/pages/cards/card-basic.vue'),
            /* no children */
          },
          {
            path: 'card-statistics',
            name: 'pages-cards-card-statistics',
            component: () => import('/app/resources/ts/pages/pages/cards/card-statistics.vue'),
            /* no children */
          },
          {
            path: 'card-widgets',
            name: 'pages-cards-card-widgets',
            component: () => import('/app/resources/ts/pages/pages/cards/card-widgets.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dialog-examples',
        /* internal name: 'pages-dialog-examples' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-dialog-examples',
            component: () => import('/app/resources/ts/pages/pages/dialog-examples/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'faq',
        name: 'pages-faq',
        component: () => import('/app/resources/ts/pages/pages/faq.vue'),
        /* no children */
      },
      {
        path: 'icons',
        name: 'pages-icons',
        component: () => import('/app/resources/ts/pages/pages/icons.vue'),
        /* no children */
      },
      {
        path: 'misc',
        /* internal name: 'pages-misc' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'coming-soon',
            name: 'pages-misc-coming-soon',
            component: () => import('/app/resources/ts/pages/pages/misc/coming-soon.vue'),
            /* no children */
          },
  _definePage_default_76
  ),
  _mergeRouteRecord(
          {
            path: 'under-maintenance',
            name: 'pages-misc-under-maintenance',
            component: () => import('/app/resources/ts/pages/pages/misc/under-maintenance.vue'),
            /* no children */
          },
  _definePage_default_77
  )
        ],
      },
      {
        path: 'pricing',
        name: 'pages-pricing',
        component: () => import('/app/resources/ts/pages/pages/pricing.vue'),
        /* no children */
      },
      {
        path: 'typography',
        name: 'pages-typography',
        component: () => import('/app/resources/ts/pages/pages/typography.vue'),
        /* no children */
      },
      {
        path: 'user-profile',
        /* internal name: 'pages-user-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-user-profile-tab',
            component: () => import('/app/resources/ts/pages/pages/user-profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_78
  )
        ],
      }
    ],
  },
  {
    path: '/password-reset',
    /* internal name: 'password-reset' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'password-reset-token',
        component: () => import('/app/resources/ts/pages/password-reset/[token].vue'),
        /* no children */
      },
  _definePage_default_79
  )
    ],
  },
  {
    path: '/recruiting',
    /* internal name: 'recruiting' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'recruiting',
        component: () => import('/app/resources/ts/pages/recruiting/index.vue'),
        /* no children */
      },
  _definePage_default_80
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'recruiting-id',
        component: () => import('/app/resources/ts/pages/recruiting/[id].vue'),
        /* no children */
      },
  _definePage_default_81
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/app/resources/ts/pages/register.vue'),
    /* no children */
  },
  _definePage_default_82
  ),
  {
    path: '/reports',
    /* internal name: 'reports' */
    /* no component */
    children: [
      {
        path: 'analytics',
        /* internal name: 'reports-analytics' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'competencies',
            name: 'reports-analytics-competencies',
            component: () => import('/app/resources/ts/pages/reports/analytics/competencies.vue'),
            /* no children */
          },
  _definePage_default_83
  ),
  _mergeRouteRecord(
          {
            path: 'tours',
            name: 'reports-analytics-tours',
            component: () => import('/app/resources/ts/pages/reports/analytics/tours.vue'),
            /* no children */
          },
  _definePage_default_84
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'ranking',
        name: 'reports-ranking',
        component: () => import('/app/resources/ts/pages/reports/ranking.vue'),
        /* no children */
      },
  _definePage_default_85
  )
    ],
  },
  {
    path: '/tables',
    /* internal name: 'tables' */
    /* no component */
    children: [
      {
        path: 'data-table',
        name: 'tables-data-table',
        component: () => import('/app/resources/ts/pages/tables/data-table.vue'),
        /* no children */
      },
      {
        path: 'simple-table',
        name: 'tables-simple-table',
        component: () => import('/app/resources/ts/pages/tables/simple-table.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/two-factor-challenge',
    name: 'two-factor-challenge',
    component: () => import('/app/resources/ts/pages/two-factor-challenge.vue'),
    /* no children */
  },
  _definePage_default_86
  ),
  {
    path: '/users',
    /* internal name: 'users' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'users-chat',
        component: () => import('/app/resources/ts/pages/users/chat.vue'),
        /* no children */
      },
  _definePage_default_87
  ),
  _mergeRouteRecord(
      {
        path: 'custom-fields',
        name: 'users-custom-fields',
        component: () => import('/app/resources/ts/pages/users/custom-fields.vue'),
        /* no children */
      },
  _definePage_default_88
  ),
  _mergeRouteRecord(
      {
        path: 'departments',
        name: 'users-departments',
        component: () => import('/app/resources/ts/pages/users/departments.vue'),
        /* no children */
      },
  _definePage_default_89
  ),
  _mergeRouteRecord(
      {
        path: 'list',
        name: 'users-list',
        component: () => import('/app/resources/ts/pages/users/list.vue'),
        /* no children */
      },
  _definePage_default_90
  ),
  _mergeRouteRecord(
      {
        path: 'positions',
        name: 'users-positions',
        component: () => import('/app/resources/ts/pages/users/positions.vue'),
        /* no children */
      },
  _definePage_default_91
  ),
      {
        path: 'view',
        /* internal name: 'users-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'users-view-id',
            component: () => import('/app/resources/ts/pages/users/view/[id].vue'),
            /* no children */
          },
  _definePage_default_92
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/verify-done',
    name: 'verify-done',
    component: () => import('/app/resources/ts/pages/verify-done.vue'),
    /* no children */
  },
  _definePage_default_93
  ),
  _mergeRouteRecord(
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('/app/resources/ts/pages/verify-email.vue'),
    /* no children */
  },
  _definePage_default_94
  ),
  {
    path: '/wizard-examples',
    /* internal name: 'wizard-examples' */
    /* no component */
    children: [
      {
        path: 'checkout',
        name: 'wizard-examples-checkout',
        component: () => import('/app/resources/ts/pages/wizard-examples/checkout.vue'),
        /* no children */
      },
      {
        path: 'create-deal',
        name: 'wizard-examples-create-deal',
        component: () => import('/app/resources/ts/pages/wizard-examples/create-deal.vue'),
        /* no children */
      },
      {
        path: 'property-listing',
        name: 'wizard-examples-property-listing',
        component: () => import('/app/resources/ts/pages/wizard-examples/property-listing.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/x',
    /* internal name: 'x' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':code',
        name: 'x-code',
        component: () => import('/app/resources/ts/pages/x/[code].vue'),
        /* no children */
      },
  _definePage_default_95
  )
    ],
  }
]
